news11.vue<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, 공인중개사 교재로 온라인서점 1위부터 22위까지 석권… ’수험서 시장 평정’</h4>
                            <div class="board_meta">
<!--                                <ul>-->
<!--                                    <li>등록일 : 22.05.24</li>-->
<!--                                    <li>조회수 : 142</li>-->
<!--                                </ul>-->
                            </div>
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                              <h2><span style="font-family:'맑은 고딕';"><strong>에듀윌,&nbsp;공인중개사 교재로 온라인서점 1위부터 22위까지 석권… ’수험서 시장 평정’</strong></span>
                              </h2>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';"><strong>- 3개월 연속 상위권 독식…4월에는 베스트셀러 상위 22권 모두 에듀윌 교재</strong></span>
                              </p>
                              <p><span style="font-family:'맑은 고딕';"><strong>-&nbsp;“양은 줄이고 핵심은 강화”…수험생들,&nbsp;빠른 회독과 높은 이해도에 ‘극찬’</strong></span>
                              </p>
                              <figure class="image"><img src="//company.eduwill.net/contents/img/20250605144127.jpg"></figure>
                              <p><span style="font-family:'맑은 고딕';">(2025-05-12) 종합교육기업 에듀윌(대표 양형남)이 출간한 공인중개사 교재가 4월 온라인서점 베스트셀러 순위를 또 한번 장악했다고 12일 밝혔다.&nbsp;에듀윌 교재는 공인중개사 부문 1위부터 22위까지를 모두 휩쓰는 진기록을 세우며 시장 내 독보적인 입지를 다시 한 번 입증했다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">이번 성과는 지난 2월과 3월에도 1위부터 16위까지 에듀윌 교재가 랭크됐던 데 이어 연속된 쾌거다.&nbsp;특히 4월에는 에듀윌의 공인중개사 교재 22종이 모두 상위권에 오르며,&nbsp;수험생 사이에서 ‘에듀윌 공인중개사 교재는 곧 합격’이라는 공식이 더욱 공고해졌다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">실제 교재를 구매한 수험생들의 반응도 뜨겁다.&nbsp;한 수험생은 “자격증 시험에 빨리 합격하려면 양을 줄여나가야 한다”며 “에듀윌 합격서는 회독하기에 최적인 학습서로 양은 줄었지만 핵심은 다 들어 있어 매우 효율적”이라고 평가했다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="color:black;font-family:'맑은 고딕';">또 다른 수험생은 “기본서를 본 후 핵심 내용만 단권화 요약하고 싶었는데,&nbsp;합격서가 딱 핵심만 압축 정리된 책이라 만족한다.&nbsp;틈틈이 읽으니 암기하기도 수월하다”며 ”단원별 기출문제집을 풀고 있는데,&nbsp;어려운 파트나 유형은 합격서를 보며 핵심개념만 빠르게 보완하는 방식으로 공부하고 있다.&nbsp;시간을 적게 쓰면서도 개념도 잘 잡히고 이해가 잘 된다. ‘공인중개사는 에듀윌’이라는 말에 고개가 끄덕여진다”고 전했다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">에듀윌 관계자는 “수험생들이 실제로 체감할 수 있는 교재의 완성도와 체계적인 커리큘럼이 좋은 반응을 얻고 있는 것 같다”며 “앞으로도 빠른 합격을 도울 수 있는 콘텐츠 개발에 집중하겠다”고 밝혔다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">에듀윌은 지난 수년간 공인중개사 분야에서 높은 합격률과 만족도를 기록하며 국내 대표 자격증 교육 기업으로 자리매김하고 있다.</span>
                              </p>
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news24" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, 프레임아웃과 손잡고 AI 기반 디지털 혁신 추진</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                              <!-- 다음 보도 기사가 있을 경우 -->
                              <li class="next">
                                <router-link to="/edu/newsRelease/promotionVideo/news22" data-value="315283">
                                  <strong>다음</strong>
                                  <span>에듀윌, 넥스트챌린지·넥스트챌린지스쿨과 MOU 체결</span>
                                </router-link>
                              </li>
                              <!-- //다음 보도 기사가 있을 경우 -->

                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
